/**
 * Gets page type from path using following format: /{LOCALE}/{IDENTIFIER}/{SLUG}
 *
 * Identifiers:
 *  product -> PDP
 *  cart -> Cart
 *
 * If no of above identifiers match, use Homepage
 *
 *
 * @param path - The path to get the page type from
 * @returns The page type
 */
export const getPageNameFromPath = (path: string) => {
    const parts = path.split("/")
    const pageType = parts[2] ?? ""

    switch (pageType) {
        case "product":
            return "PDP"
        case "cart":
            return "Cart"
        case "categories":
            return "PLP"
        default:
            return "Homepage"
    }

    return ""
}
